import { render, staticRenderFns } from "./SelectCart.vue?vue&type=template&id=235c3b28"
import script from "./SelectCart.vue?vue&type=script&lang=js"
export * from "./SelectCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('235c3b28')) {
      api.createRecord('235c3b28', component.options)
    } else {
      api.reload('235c3b28', component.options)
    }
    module.hot.accept("./SelectCart.vue?vue&type=template&id=235c3b28", function () {
      api.rerender('235c3b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectCart.vue"
export default component.exports